import { PlaceholdersId, TFComponent } from '@types';

import { CorporateDataPlaceholder } from './corporateData';

export const corporateData: TFComponent = {
	component: CorporateDataPlaceholder,
	id: PlaceholdersId.corporateData,
	name: 'corporateData',
};
